import { SelectField } from '@/components'
import { isSingleProjectPlan, PLAN_KINDS, useAccount } from '@/modules/account'
import { useLoadingPlans, usePlans } from '@/modules/auth'

interface PlansSelectorProps {
  value?: string
  error?: string | null
  setFieldValue: (name: string, value?: string) => void
  isMutating?: boolean
}

export const PlansSelector = ({
  value,
  error,
  setFieldValue,
}: PlansSelectorProps) => {
  const plans = usePlans()
  const account = useAccount()

  const filteredPlans = isSingleProjectPlan(account?.planKind)
    ? plans?.filter((plan) => plan.kind !== PLAN_KINDS.single_project)
    : plans

  const isLoadingPlans = useLoadingPlans()

  return (
    <SelectField
      label="Plan"
      id="plan"
      isLoading={isLoadingPlans}
      placeholder="Select a plan"
      value={value ?? ''}
      error={error}
      required
      onValueChange={(value: string) => {
        setFieldValue('priceId', value)
      }}
      options={filteredPlans?.map((plan) => ({
        label: plan.displayName,
        value: plan.priceId,
      }))}
    />
  )
}
